<template>
    <div id="apply-modifier-to-item">
        <vs-popup title="Apply Modifier To Item" class="apply-modifier-to-item" :active.sync="config.isActive" @close="closePopup">
            <div>
                <div class="p-6 w-full" style="position: absolute; top: 0; left: 0">
                    <div class="con-input-search vs-table--search m-0" style="max-width: unset">
                        <input type="text" class="input-search vs-table--search-input rounded-item border-custom w-full py-3 text-sm" @input="searchItem" placeholder="Search item...">
                        <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                    </div>
                </div>
                <div class="border-top-custom bg-custom" style="max-height: calc(100vh - 310px); overflow-y: auto; margin-top: 69px;">
                    <div class="px-5" v-if="item_list && item_list.length > 0">
                        <vx-card class="my-5 overflow-hidden md:p-0 p-5" v-for="(item, index) in item_list" :key="index" :class="{'is-selected': item.checked}">
                            <div class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default p-6">
                            <input type="checkbox" class="vs-checkbox--input" :id="item.id" v-model="item.checked">
                            <span class="checkbox_x vs-checkbox" style="border: 2px solid rgb(180, 180, 180);">
                                <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
                            </span>
                            <span class="con-slot-label">
                                <div class="title pl-4">{{item.name}}</div>
                                </span>
                            </div>
                        </vx-card>
                    </div>
                    <div v-else class="w-full h-full flex align-center justify-center" style="padding: 100px;">
                        No data available
                    </div>
                </div>
            </div>
        </vs-popup>  
    </div>  
</template>

<script>
    export default {
        name: 'apply-modifier-to-item',
        props: {
            config: {
                type: Object
            }
        },
        data() {
            return {
                item_list: [
                    {id: 0, name: 'Item 1', checked: true},
                    {id: 1, name: 'Item 2', checked: false},
                    {id: 2, name: 'Item 3', checked: true},
                    {id: 3, name: 'Item 4', checked: true},
                    {id: 4, name: 'Item 5', checked: false},
                    {id: 5, name: 'Item 6', checked: true},
                    {id: 6, name: 'Item 7', checked: true},
                    {id: 7, name: 'Item 8', checked: false},
                ]
            }
        },
        methods: {
            closePopup() {

            },
            searchItem() {

            }
        }
    }
</script>